import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQbrPptxReportError = createSelector(
  [selectQbrState],
  ({ pptxReportState }) => pptxReportState.error
)
